import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  box: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
  },
});
export default useStyles;
